module.exports = __webpack_public_path__ + "static/banner-87ab3d13ac110ff925974d0df54b460c.svg";